import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["alert", "container"];

  connect() {
    this.currentIndex = 0;
    this.dismissedIds = this.getDismissedIds();
    this.filterDismissedAlerts();
    if (this.alertTargets.length > 0) {
      this.containerTarget.classList.remove("hidden");
      this.showCurrentAlert();
    } else {
      this.containerTarget.classList.add("hidden");
    }
  }

  next() {
    if (this.currentIndex < this.alertTargets.length - 1) {
      this.currentIndex++;
      this.showCurrentAlert();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.showCurrentAlert();
    }
  }

  close(event) {
    // Find the current alert element and get its data-id
    const currentAlert = this.alertTargets[this.currentIndex];
    if (!currentAlert) return;
    const alertId = currentAlert.dataset.id;
    if (alertId) {
      this.saveDismissedId(alertId);
    }
    // Remove the alert from DOM
    currentAlert.remove();
    // If there are alerts left, show the first one
    if (this.alertTargets.length > 0) {
      this.currentIndex = 0;
      this.showCurrentAlert();
    } else {
      this.containerTarget.classList.add("hidden");
    }
  }

  showCurrentAlert() {
    this.alertTargets.forEach((el, idx) => {
      el.classList.toggle("hidden", idx !== this.currentIndex);
    });
  }

  getDismissedIds() {
    try {
      return JSON.parse(localStorage.getItem("remixtDismissedAlerts") || "[]");
    } catch {
      return [];
    }
  }

  saveDismissedId(id) {
    let ids = this.getDismissedIds();
    if (!ids.includes(id)) {
      ids.push(id);
      localStorage.setItem("remixtDismissedAlerts", JSON.stringify(ids));
    }
  }

  filterDismissedAlerts() {
    // Remove alerts from DOM that are dismissed
    this.alertTargets.forEach((el) => {
      const alertId = el.dataset.id;
      if (alertId && this.dismissedIds.includes(alertId)) {
        el.remove();
      }
    });
  }
}
